module.exports = __webpack_public_path__ + "static/img/informe psico.7a18ff12.png";